<template>
  <div>
    <CCard>
      <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
        <CRow class="flex-flow-column">
          <CCol>
            <strong>{{ title }}</strong>
          </CCol>
          <p class="desc">{{ $t("cReport.desc") }}</p>

         
        </CRow>
         <div
              @click="toggleJsonExcelModal()"
              class="generate-ex-btn"
              v-if="lsReportTableData&&lsReportTableData.length>0"
            >
              <img src="@imgPath/img/svg/icons/excle-icon.svg" alt />
            </div>
      </CCardHeader>

      <CCardBody>
        <!--          <CRow class="bring_front" >-->
        <!--            <CCol class="col-form-label col-sm-12">-->

        <!--            </CCol>-->
        <!--          </CRow>-->
        <ValidationObserver v-slot="{ handleSubmit }">

          <div class="bring_front">
            <CRow>
              <CCol md="3" v-if="isSystemReport&&!isSummary&&isNeedAgentSelection">
                <div>
                  <ValidationProvider class="w-100" tag="div" rules="required" v-slot="{ errors }">
                    <cAgent
                      v-model="agents"
                      :ctrlName="'agencyname'"
                      :ctrlCode="'b2bid'"
                      :isShowCode="true"
                      :isSearchable="true"
                      @input="onChangeAgent"
                      :isNeedAgntDetails="false"
                      :isAll="isAllAgentSelOption"
                      :b2bCodeToSelectAgent="null"
                      :label="$t('cReport.agent')"
                      :agentType="agentType"
                      :toShowAgencyGroup="true"
                    />
                    <div v-if="errors && errors[0]" class="invalid-feedback icon">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </div>
              </CCol>
              <CCol  md="3" >
                <!-- :md="(!isSystemReport && reportName=='TopupForecastReport')?4:3" -->
                <cReportCurrDp
                  v-model="report.currency"
                  :isAll="true"
                  :selValue="report.currency"
                  :label="$t('cReport.currency')"
                  :ctrlCode="'id'"
                  :isShowCode="true"
                  :isMultiple="true"
                  :isSearchable="true"
                  :isAllowEmpty="false"
                  v-on:input="getSelCurrency"
                ></cReportCurrDp>
              </CCol>
              <CCol md="4">
                <div class="ext-date-wrapper">
                  <label for>{{dateSelectionTitle}}</label>
                  <v-md-date-range-picker
                    :opens="isOpenDatePickerRight?'left':'right'"
                    :autoApply="true"
                    :showYearSelect="true"
                    :start-date=" report.fromDate?report.fromDate.toString():new Date().toString()"
                    :end-date="report.toDate?report.toDate.toString():new Date().toString()"
                    :maxYear="getMaxYear()"
                    :minYear="getMinYear()"
                    @change="onChangeDate"
                    class="ext-date-wrapper"
                  >
                    <template slot="input">
                      <datePickerInput
                        :fromDate="report.fromDate?report.fromDate:null"
                        :toDate="report.toDate?report.toDate:null"
                        :fromLabel="$t('cReport.fromDate')"
                        :toLabel="$t('cReport.toDate')"
                        class="ext-date-wrapper"
                      />
                    </template>
                  </v-md-date-range-picker>
                </div>
              </CCol>
              <CCol md="2">
                <label></label>
                <CButton
                  class="mt-8px btn-info w-100"
                  type="submit"
                  @click.prevent="handleSubmit(onReportFormSubmit)"
                >{{$t('cReport.submitBtn')}}</CButton>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="3" v-if="isAirlineSelection">
                <label>{{$t('cReport.airline')}}</label>
                <ValidationProvider :rules="'required'" v-slot="{ errors }">
                  <multiselect
                    v-model="selAirline"
                    :multiple="isMultipleALSel"
                    :allow-empty="false"
                    :options="lsAirlines"
                    :track-by="'airline_code'"
                    :showLabels="false"
                    :placeholder="$t('cReport.airlinePl')"
                    @input="onSelAirline"
                    :custom-label="customLabelForAirline"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">
                      <div class="d-flex">
                        <span>{{ option['airline_name'] }}</span>
                        <strong class="right ml-auto">
                          {{
                          option['airline_code']=='All'?'':option['airline_code']
                          }}
                        </strong>
                      </div>
                    </template>
                    <template slot="option" slot-scope="props">
                      <div class="d-flex">
                        <span>{{ props.option['airline_name'] }}</span>
                        <strong class="right ml-auto">
                          {{
                          props.option['airline_code']=='All'?'':props.option['airline_code']
                          }}
                        </strong>
                      </div>
                    </template>
                    <template #noResult>
                      <strong>{{$t('cReport.listEmpty')}}</strong>
                    </template>
                  </multiselect>
                  <div v-if="errors && errors[0]" class="invalid-feedback icon">
                    <span>{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </CCol>
              <CCol md="3" v-if="isProviderSelection">
                <label>{{$t('cReport.gds')}}</label>
                <ValidationProvider :rules="'required'" v-slot="{ errors }">
                  <multiselect
                    v-model="selProvider"
                    :multiple="isMultipleProviderSel"
                    :allow-empty="false"
                    :options="lsProviders"
                    :track-by="'providerid'"
                    :showLabels="false"
                    :placeholder="$t('cReport.gdsPl')"
                    @input="onSelProvider"
                    :custom-label="customLabelForProvider"
                  >
                    <template #noResult>
                      <strong>{{$t('cReport.listEmpty')}}</strong>
                    </template>
                  </multiselect>
                  <div v-if="errors && errors[0]" class="invalid-feedback icon">
                    <span>{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </CCol>
            </CRow>
          </div>
        </ValidationObserver>
        <br v-if="lsReportData" />
        <div class="pr-15px pl-15px mt-20px" v-if="lsReportData&&isNeedOverTableData">
          <CRow class="p-10">
            <CCol class="card report-wrap-c col-md-3" v-if="!isSummary&&(lsReportData.agencyname||lsReportData.agencyName)" >
              <div class="profile-drop-wrap none">
                <div class="head" >
                  <div class="profile">
                    <avatar
                      v-if="lsReportData.agencyname"
                      class="c-avatar-img square"
                      :username="lsReportData.agencyname?lsReportData.agencyname:lsReportData.groupName"
                      :size="80"
                      color="#fff"
                    ></avatar>
                    <avatar
                      v-if="lsReportData.agencyName"
                      class="c-avatar-img square"
                      :username="lsReportData.agencyName?lsReportData.agencyName:lsReportData.groupName"
                      :size="80"
                      color="#fff"
                    ></avatar>
                  </div>
                  <div class="details">
                    <div
                      class="name"
                    >{{ lsReportData.agencyname?lsReportData.agencyname:lsReportData.groupName }}</div>
                    <div
                      class="name"
                    >{{ lsReportData.agencyName?lsReportData.agencyName:lsReportData.groupName }}</div>
                    <div class="profile-t-tag">
                      <div
                        v-if="
                  lsReportData.b2bcode
                "
                      >{{ lsReportData.b2bcode }}</div>
                      <div
                        class="profile-t-tag"
                        v-if="
                  lsReportData.b2bCode
                "
                      >
                        <div>{{ lsReportData.b2bCode }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </CCol>
            <CCol class="card report-wrap-c  col-md-3" v-if="!isSummary&&reportDetails" >
              <div class="profile-drop-wrap none">
                <div class="head" >
                  <div class="profile">
                    <avatar
                      v-if="reportDetails.name"
                      class="c-avatar-img square"
                      :username="reportDetails.name"
                      :size="80"
                      color="#fff"
                    ></avatar>
                  
                  </div>
                  <div class="details">
                    <div
                      class="name"
                    >{{ reportDetails.name }}</div>
                   
                    <div class="profile-t-tag">
                      <div
                        v-if="
                  reportDetails.mobileNumber
                "
                      >{{ reportDetails.mobileNumber }}</div>
                    
                    </div>
                      <div class="profile-t-tag">
                      <div
                        v-if="
                  reportDetails.emailid
                "
                      >{{ reportDetails.emailid }}</div>
                    
                    </div>
                  </div>
                </div>
              </div>
            </CCol>

            <!-- <CCol class="card report-wrap-c" v-if="!isSummary">
              <div class="profile-drop-wrap none">
                <div class="head">
                  <div class="profile">
                    <avatar
                      v-if="lsReportData.agencyname"
                      class="c-avatar-img square"
                      :username="lsReportData.agencyname?lsReportData.agencyname:lsReportData.groupName"
                      :size="80"
                      color="#fff"
                    ></avatar>
                  </div>
                  <div class="details">
                    <div
                      class="name"
                    >{{ lsReportData.agencyname?lsReportData.agencyname:lsReportData.groupName }}</div>
                    <div
                      class="profile-t-tag"
                      v-if="
                  lsReportData.b2bcode
                "
                    >
                      <div>{{ lsReportData.b2bcode }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </CCol>-->
            <CCol class="card report-wrap-c  col-md-3" v-if="lsReportData.total">
              <div>
                <div class="mb-10px">{{$t('cReport.agentSales')}}</div>
                <div class="currecncy" v-for="(curr,index) in selCurrency" :key="index">
                  <span  v-if="curr && curr.currency_code">{{curr.currency_code.code+' '}}</span>
                  <span
                    v-if="lsReportData.total[curr.currency_code.code]&&lsReportData.total[curr.currency_code.code].agentsales"
                  >{{lsReportData.total[curr.currency_code.code].agentsales.toString()|formatNumber(curr.currency_code.code)}}</span>
                  <span v-else>{{'0'}}</span>
                  <br />
                </div>
                <div
                  class="cur-des"
                >{{isSummary?$t('cReport.selPeriodCredit'):$t('cReport.selPeriodAgentSales')}}</div>
              </div>
            </CCol>
            <CCol class="card report-wrap-c  col-md-3" v-if="lsReportData.total">
              <div>
                <div class="mb-10px">{{$t('cReport.agentPaymentSettlement')}}</div>
                <div class="currecncy" v-for="(curr,index) in selCurrency" :key="index">
                  <span v-if="curr && curr.currency_code">{{curr.currency_code.code+' '}}</span>
                  <span
                    v-if="lsReportData.total[curr.currency_code.code]&&lsReportData.total[curr.currency_code.code].agentpayment"
                  >{{lsReportData.total[curr.currency_code.code].agentpayment.toString()|formatNumber(curr.currency_code.code)}}</span>
                  <span v-else>{{'0'}}</span>
                  <br />
                </div>
                <div
                  class="cur-des"
                >{{isSummary?$t('cReport.selPeriodDebit'):$t('cReport.selPeriodAgentPayment')}}</div>
              </div>
            </CCol>
             <CCol class="card report-wrap-c  col-md-3" v-if="lsReportData.total&&isCreditDebitTotal">
              <div>
                <div class="mb-10px">{{$t('cReport.creditDebit')}}</div>
                <div class="currecncy" v-for="(curr,index) in selCurrency" :key="index">
                  <span  v-if="curr && curr.currency_code">{{curr.currency_code.code+' '}}</span>
                  <span
                    v-if="lsReportData.total[curr.currency_code.code]&&lsReportData.total[curr.currency_code.code].creditdebit"
                  >{{lsReportData.total[curr.currency_code.code].creditdebit.toString()|formatNumber(curr.currency_code.code)}}</span>
                  <span v-else>{{'0'}}</span>
                  <br />
                </div>
                <div
                  class="cur-des"
                >{{$t('cReport.selPeriodCreditOrDebit')}}</div>
              </div>
            </CCol>
            <CCol class="card report-wrap-c  col-md-3" v-if="lsReportData.total&&isSummary">
              <div>
                <div class="mb-10px">{{$t('cReport.openingBalance')}}</div>
                <div class="currecncy" v-for="(curr,index) in selCurrency" :key="index">
                  <span  v-if="curr && curr.currency_code">{{curr.currency_code.code+' '}}</span>
                  <span
                    v-if="lsReportData.total[curr.currency_code.code]&&lsReportData.total[curr.currency_code.code].openingbalance"
                  >{{lsReportData.total[curr.currency_code.code].openingbalance.toString()|formatNumber(curr.currency_code.code)}}</span>
                  <span v-else>{{'0'}}</span>
                  <br />
                </div>
                <div class="cur-des" v-if="isSummary">{{$t('cReport.selPeriodOpeningBalance')}}</div>
              </div>
            </CCol>

            <CCol class="card report-wrap-c  col-md-3" v-if="lsReportData.total&&!isCreditBalance">
              <div>
                <div
                  class="mb-10px"
                >{{isSummary?$t('cReport.closingBalance'):$t('cReport.availableBalance')}}</div>
                <div class="currecncy" v-for="(curr,index) in selCurrency" :key="index">
                  <span  v-if="curr && curr.currency_code">{{curr.currency_code.code+' '}}</span>
                  <span
                    v-if="lsReportData.total[curr.currency_code.code]&&lsReportData.total[curr.currency_code.code].closingbalance"
                  >{{lsReportData.total[curr.currency_code.code].closingbalance.toString()|formatNumber(curr.currency_code.code)}}</span>
                  <span v-else>{{'0'}}</span>
                  <br />
                </div>
                <div class="cur-des" v-if="isSummary">{{$t('cReport.selPeriodClosingBalance')}}</div>
              </div>
            </CCol>
              <CCol class="card report-wrap-c  col-md-3" v-if="lsReportData.total&&isCreditBalance">
              <div>
                <div
                  class="mb-10px"
                >{{$t('cReport.creditBalance')}}</div>
                <div class="currecncy" v-for="(curr,index) in selCurrency" :key="index">
                  <span v-if="curr && curr.currency_code">{{curr.currency_code.code+' '}}</span>
                  <span
                    v-if="lsReportData.total[curr.currency_code.code]&&lsReportData.total[curr.currency_code.code].after_amount"
                  >{{lsReportData.total[curr.currency_code.code].after_amount.toString()|formatNumber(curr.currency_code.code)}}</span>
                  <span v-else>{{'0'}}</span>
                  <br />
                </div>
                <div class="cur-des" v-if="isSummary">{{$t('cReport.selPeriodClosingBalance')}}</div>
              </div>
            </CCol>
            <CCol class="card report-wrap-c  col-md-3" v-if="lsReportData.hasOwnProperty('overDue')">
              <div class="profile-drop-wrap none">
              <div class="head">
                <span class="mb-10px">{{$t('cReport.overdue')}}</span>

                <strong class="pl-10px">{{lsReportData.overDue}}</strong>
              </div>
              </div>
            </CCol>
            <CCol class="card report-wrap-c  col-md-6" v-if="lsReportData.NowAvailableLimit">
            <CRow >
              <CCol md="6">
                <CRow class="emptyrow"></CRow>
                <CRow>{{$t('cReport.availableLimitAsAtToday')}}</CRow>
                <CRow>{{$t('cReport.predictedTicketIssueAmount')}}</CRow>
                <CRow>{{$t('cReport.balance')}}</CRow>
              </CCol>
              <!-- <div>
              <div v-for="(curr,index) in selCurrency" :key="index">-->
              <!-- <span>{{curr.currency_code.symbol+' '}}</span> -->
              <CCol md="2" v-for="(curr,index) in selCurrency" :key="index">
                <CRow
                  class="currecncy"
                  v-if="lsReportData.NowAvailableLimit[curr.currency_code.code]"
                >{{curr.currency_code.code}}</CRow>
                <CRow
                  v-if="lsReportData.NowAvailableLimit[curr.currency_code.code]"
                >{{lsReportData.NowAvailableLimit[curr.currency_code.code].toString()|formatNumber(curr.currency_code.code)}}</CRow>
                <CRow v-else>{{'0'}}</CRow>
                <CRow
                  v-if="lsReportData.predictAmount[curr.currency_code.code]"
                >{{lsReportData.predictAmount[curr.currency_code.code].toString()|formatNumber(curr.currency_code.code)}}</CRow>
                <CRow v-else>{{'0'}}</CRow>

                <CRow
                  v-if="lsReportData.afterAvailableLimit[curr.currency_code.code]"
                >{{lsReportData.afterAvailableLimit[curr.currency_code.code].toString()|formatNumber(curr.currency_code.code)}}</CRow>
                <CRow v-else>{{'0'}}</CRow>
              </CCol>
              <br />
              <!-- </div>
              </div>-->
            </CRow>
            </CCol>
            <CRow v-if="lsReportData.availableAmount" class="amoundcard">
              <CCol>
                <CRow class="emptyrow"></CRow>
                <CRow>{{$t('cReport.availableLimitAsAtToday')}}</CRow>
                <CRow>{{$t('cReport.predictedTicketIssueAmount')}}</CRow>
                <CRow>
                  <strong>{{$t('cReport.balance')}}</strong>
                </CRow>
              </CCol>
              <!-- <div>
              <div v-for="(curr,index) in selCurrency" :key="index">-->
              <!-- <span>{{curr.currency_code.symbol+' '}}</span> -->
              <CCol class="report-wrap-c" v-for="(curr,index) in selCurrency" :key="index">
                <CRow
                  class="currecncy"
                  v-if="lsReportData.availableAmount[curr.currency_code.code]"
                >{{curr.currency_code.code}}</CRow>
                <CRow
                  v-if="lsReportData.availableAmount[curr.currency_code.code]"
                >{{lsReportData.availableAmount[curr.currency_code.code].toString()|formatNumber(curr.currency_code.code)}}</CRow>
                <CRow v-else>{{'0'}}</CRow>
                <CRow
                  v-if="lsReportData.predictAmount&&lsReportData.predictAmount[curr.currency_code.code]"
                >{{lsReportData.predictAmount[curr.currency_code.code].toString()|formatNumber(curr.currency_code.code)}}</CRow>
                <CRow v-else>{{'0'}}</CRow>

                <CRow v-if="lsReportData.balance&&lsReportData.balance[curr.currency_code.code]">
                  <strong>{{lsReportData.balance[curr.currency_code.code].toString()|formatNumber(curr.currency_code.code)}}</strong>
                </CRow>
                <CRow v-else-if="lsReportData.afterBalance&&lsReportData.afterBalance[curr.currency_code.code]">
                  <strong>{{lsReportData.afterBalance[curr.currency_code.code].toString()|formatNumber(curr.currency_code.code)}}</strong>
                </CRow>
                <CRow v-else>
             <strong>{{0}}</strong>
                </CRow>
              </CCol>
              <br />
              <!-- </div>
              </div>-->
            </CRow>
          </CRow>
        </div>

        <!--        <br />-->
        <div>
          <!-- <cFullScreen class="w-100">
          <template #fullScreen>-->
<!--          striped-->
 <div class="totalsection" v-if="lsReportData&&lsReportData.total&&(isHeaderTopTotal||isFooterTotal||isDateSectionAndFooterTotal)">
      <div class="maintitle">{{$t("cReport.total")}}</div>
    
<CRow>
<CCol   v-for="(field, index) in providerSlots" :key="index">
              <div>
                <!-- <div
                  class="mb-10px"
                >{{field.label}}</div> -->
                <div 
                                v-for="(currency,index) in selCurrency"
                                :key="index">
                                <div  v-if="index==0&&lsReportData.total[currency.currency_code.code]&&lsReportData.total[currency.currency_code.code].hasOwnProperty(field.slotName)"
                  class="mb-10px title"
                > {{field.label}}</div>
                  <!-- <span>{{currency.currency_code.symbol+' '}}</span> -->
                  <p  v-if="lsReportData.total[currency.currency_code.code]&&lsReportData.total[currency.currency_code.code].hasOwnProperty(field.slotName)">
<span v-if="lsReportData.total[currency.currency_code.code][field.slotName]&&   currency && currency.currency_code">{{currency.currency_code.code+' '}}
{{lsReportData.total[currency.currency_code.code][field.slotName]|formatNumber(currency.currency_code.code)}}</span>
<span v-else-if='currency && currency.currency_code'>
  {{currency.currency_code.code+' '}}{{0}}
</span>
                  </p>
                  <span  v-else>
                    {{selCurrency&&index==selCurrency.length-1?lsReportData.total[field.slotName]:''}}
                  </span>
                 
                  <br />
                </div>
              </div>
            </CCol>
            </CRow>
      </div>
      
      <div >

      </div>
          <cTable
            :fields="listReportFields"
            :items="isDateSectionAndFooterTotal?reportComputedList:lsReportTableData"
            items-per-page-select
            :items-per-page="cReportTableWatchList.itemsPerPage"
            hover

            pagination
            :loading="isLoading"
            id="user-manage-table"
            class="w-100 d-flex flex-flow-wrap creport"
            @filtered-items-change="getFilteredAgentCount"
            @page-change="onPageChange"
            @pagination-change="onPaginationChange"
            @getFields="onSaveColumns"
            :tableWatchList="cReportTableWatchList"
            :manageColumn="true"
            :paginationLenOption="true"
          >
            <!-- class="w-100 d-flex flex-flow-wrap" -->

            
            <template #ts="{item}">
              <td>
                <div>{{item.ts|formatDateTime}}</div>
              </td>
            </template>
             <!-- <template #reservasionid="{item}">
              <td>
                <div>{{item.reservasionid?item.reservasionid:''}}</div>
              </td>
            </template>
            <template #reservationId="{item}">
              <td>
                <div>{{item.reservationId?item.reservationId:''}}</div>
              </td>
            </template> -->
            <template #time="{item}">
              <td>
                <div>{{item.time|formatDateTime}}</div>
              </td>
            </template>
            <template #ticketingDeadline="{item}">
              <td v-if="item.ticketingDeadline">
                <div>{{item.ticketingDeadline|formatDate(DATE_TIME_FORMAT.REPORT_DATE_FORMAT)}}</div>
              </td>
              <td v-else>
                <div>{{''}}</div>
              </td>
            </template>
            <template #booked_ts="{item}">
              <td v-if="item.booked_ts">
                <div>{{item.booked_ts|formatDate(DATE_TIME_FORMAT.REPORT_DATE_FORMAT)}}</div>
              </td>
              <td v-else>
                <div>{{''}}</div>
              </td>
            </template>
            <template #daysLeft="{item}">
              <td v-if="item.ticketingDeadline">
                <div>{{item.ticketingDeadline|timeLeftFormat}}</div>
              </td>
              <td v-else>
                <div>{{''}}</div>
              </td>
            </template>
            <template #invoice="{item}">
              <td>
                <div>{{item.invoice?item.invoice:''}}</div>
              </td>
            </template>
            <template #reference="{item}">
              <td>
                <div>{{item.reference?item.reference:''}}</div>
              </td>
            </template>
            <template #description="{item}">
              <td>
                <div>{{item.description?item.description:item.descreption?item.descreption:''}}</div>
              </td>
            </template>
            <template #transactiontype="{item}">
              <td>
                <div>{{item.transactiontype?item.transactiontype:item.transactionType?item.transactionType:''}}</div>
              </td>
            </template>
            <!-- <template #transactiontype="{item}">
              <td>
                <div
                  class="margin-left: 10px; margin-right: 10px;"
                >{{item.transactiontype?item.transactiontype:''}}</div>
              </td>
            </template> -->
            <template #orderId="{item}">
              <td>
                <div>{{item.orderId?item.orderId:item.reservationId?item.reservationId:item.reservasionid?item.reservasionid:item.orderid?item.orderid:''}}</div>
              </td>
            </template>
            <template #date="{item}">
              <td>
                <div>{{item.date|formatDateTime}}</div>
              </td>
            </template>
            <template #firstname="{item}">
              <td>
                <div>{{item.firstname+' '+item.lastname}}</div>
              </td>
            </template>
            <template #booking_ref="{item}">
              <td>
                <div>{{item.booking_ref?item.booking_ref:''}}</div>
              </td>
            </template>
            <template #tickets="{item}">
              <td>
                <div v-for="(ticketNum,index) in item.tickets" :key="index">{{ticketNum}}</div>
              </td>
            </template>
              <template #pnr="{item}">
              <td>
                <div v-for="(pnrValue,index) in item.pnr.split(',')" :key="index">{{pnrValue}}</div>
              </td>
            </template>
            <template #route="{item}">
              <td>
                <div>{{item.route?item.route:''}}</div>
              </td>
            </template>
            <template #citizentype="{item}">
              <td>
                <div>{{item.citizentype?item.citizentype:''}}</div>
              </td>
            </template>
            <template #class="{item}">
              <td>
                <div
                  v-if="item.flight_info.obFlight"
                >{{item.flight_info.obFlight[0].flight.Bookingclass}}</div>
                <div
                  v-if="item.flight_info.ibFlight"
                >{{item.flight_info.ibFlight[0].flight.Bookingclass}}</div>
              </td>
            </template>
            <template #tourCode="{item}">
              <td>
                <div>{{item.tourCode?item.tourCode:''}}</div>
              </td>
            </template>
             <template #transactionid="{item}">
              <td>
                <div>{{item.transactionid?item.transactionid:''}}</div>
              </td>
            </template>
            <!-- <template #cashOrCreditSales="{item}">
              <td>
                <CRow class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                  <span>{{currency.currency_code.code+' '}}{{item[currency.currency_code.code]['Credit Sales'].toString()|formatNumber(currency.currency_code.code)}}</span>
                </CRow>
              </td>
            </template> -->
            <template #agentsales-header>
              <div class="mr-10px ml-10px">
                <div class="text-center">{{$t('cReport.agentSales')}}</div>
                <CRow>
                  <CCol
                    class="text-center"
                    v-for="(currency,index) in selCurrency"
                    :key="index"
                  >{{currency.currency_code.code}}</CCol>
                </CRow>
              </div>
            </template>

            <template #bookingAmount-header>
              <div class="mr-10px ml-10px">
                <div class="text-center">{{$t('cReport.holdBookings')}}</div>
                <CRow>
                  <CCol
                    class="text-center"
                    v-for="(currency,index) in selCurrency"
                    :key="index"
                  >{{currency.currency_code.code}}</CCol>
                </CRow>
              </div>
            </template>
            <template #bookingAmount="{item}">
              <td>
                <div>
                  <CRow>
                    <CCol class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                      <div
                        v-if="item[currency.currency_code.code].bookingAmount"
                      >{{item[currency.currency_code.code].bookingAmount.toString()|formatNumber(currency.currency_code.code)}}</div>
                    </CCol>
                  </CRow>
                </div>
              </td>
            </template>
              <template #after_amount-header>
              <div class="mr-10px ml-10px">
                <div class="text-center">{{$t('cReport.creditBalance')}}</div>
                <CRow>
                  <CCol
                    class="text-center"
                    v-for="(currency,index) in selCurrency"
                    :key="index"
                  >{{currency.currency_code.code}}</CCol>
                </CRow>
              </div>
            </template>
            <template #after_amount="{item}">
              <td>
                <div>
                  <CRow>
                    <CCol class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                      <div
                        v-if="item[currency.currency_code.code].after_amount"
                      >{{item[currency.currency_code.code].after_amount.toString()|formatNumber(currency.currency_code.code)}}</div>
                    </CCol>
                  </CRow>
                </div>
              </td>
            </template>
            <template #availableLimit-header>
              <div>
                <div class="d-flex">
                  <div>{{$t('cReport.availableLimit')}}</div>
                </div>
                <CRow>
                  <CCol
                    class="text-center"
                    v-for="(currency,index) in selCurrency"
                    :key="index"
                  >{{currency.currency_code.code}}</CCol>
                </CRow>
              </div>
            </template>

            <template #availableLimit="{item}">
              <td>
                <div>
                  <CRow>
                    <CCol class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                      <div
                        v-if="item[currency.currency_code.code].availableLimit"
                      >{{item[currency.currency_code.code].availableLimit.toString()|formatNumber(currency.currency_code.code)}}</div>
                    </CCol>
                  </CRow>
                </div>
              </td>
            </template>
            <template #afterBalance-header>
              <div>
                <div class="d-flex">
                  <div>{{$t('cReport.availableLimit')}}</div>
                </div>
                <CRow>
                  <CCol
                    class="text-center"
                    v-for="(currency,index) in selCurrency"
                    :key="index"
                  >{{currency.currency_code.code}}</CCol>
                </CRow>
              </div>
            </template>

            <template #afterBalance="{item}">
              <td>
                <div>
                  <CRow>
                    <CCol class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                      <div
                        v-if="item[currency.currency_code.code].afterBalance"
                      >{{item[currency.currency_code.code].afterBalance.toString()|formatNumber(currency.currency_code.code)}}</div>
                    </CCol>
                  </CRow>
                </div>
              </td>
            </template>

            <template #agentsales="{item}">
              <td>
                <div>
                  <CRow>
                    <CCol class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                      <div
                        v-if="item[currency.currency_code.code].agentsales"
                      >{{item[currency.currency_code.code].agentsales.toString()|formatNumber(currency.currency_code.code)}}</div>
                    </CCol>
                  </CRow>
                </div>
              </td>
            </template>

            <template #agentpayment-header>
              <div class="mr-10px ml-10px">
                <div
                  class="text-center"
                >{{agentType==2?$t('cReport.agentPayment'):$t('cReport.agentPaymentSettlement')}}</div>
                <CRow>
                  <CCol
                    class="text-center"
                    v-for="(currency,index) in selCurrency"
                    :key="index"
                  >{{currency.currency_code.code}}</CCol>
                </CRow>
              </div>
            </template>

            <template #agentpayment="{item}">
              <td>
                <div>
                  <CRow>
                    <CCol class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                      <div
                        v-if="item[currency.currency_code.code].agentpayment"
                      >{{item[currency.currency_code.code].agentpayment.toString()|formatNumber(currency.currency_code.code)}}</div>
                    </CCol>
                  </CRow>
                </div>
              </td>
            </template>

            <template #creditdebit-header>
              <div class="mr-10px ml-10px">
                <div class="text-center">{{$t('cReport.creditDebit')}}</div>
                <CRow>
                  <CCol
                    class="text-center"
                    v-for="(currency,index) in selCurrency"
                    :key="index"
                  >{{currency.currency_code.code}}</CCol>
                </CRow>
              </div>
            </template>

            <template #creditdebit="{item}">
              <td>
                <div>
                  <CRow>
                    <CCol class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                      <div
                        v-if="item[currency.currency_code.code].creditdebit"
                      >{{item[currency.currency_code.code].creditdebit.toString()|formatNumber(currency.currency_code.code)}}</div>
                    </CCol>
                  </CRow>
                </div>
              </td>
            </template>

            <template #openingbalance-header>
              <div class="mr-10px ml-10px">
                <div class="text-center">{{$t('cReport.openingBalance')}}</div>
                <CRow>
                  <CCol
                    class="text-center"
                    v-for="(currency,index) in selCurrency"
                    :key="index"
                  >{{currency.currency_code.code}}</CCol>
                </CRow>
              </div>
            </template>

            <template #openingbalance="{item}">
              <td>
                <div>
                  <CRow>
                    <CCol class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                      <div
                        v-if="item[currency.currency_code.code].openingbalance"
                      >{{item[currency.currency_code.code].openingbalance.toString()|formatNumber(currency.currency_code.code)}}</div>
                    </CCol>
                  </CRow>
                </div>
              </td>
            </template>
            <template #closingbalance-header>
              <div>
                <div class="d-flex">
                  <div>{{isSummary?$t('cReport.closingBalance'):$t('cReport.balance')}}</div>
                </div>
                <CRow>
                  <CCol
                    class="text-center"
                    v-for="(currency,index) in selCurrency"
                    :key="index"
                  >{{currency.currency_code.code}}</CCol>
                </CRow>
              </div>
            </template>

            <template #closingbalance="{item}">
              <td>
                <div>
                  <CRow>
                    <CCol class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                      <div
                        v-if="item[currency.currency_code.code].closingbalance"
                      >{{item[currency.currency_code.code].closingbalance.toString()|formatNumber(currency.currency_code.code)}}</div>
                    </CCol>
                  </CRow>
                </div>
              </td>
            </template>

            <template #availablelimit-header>
              <div>
                <div class="d-flex">
                  <div>{{$t('cReport.availableLimit')}}</div>
                </div>
                <CRow>
                  <CCol
                    class="text-center"
                    v-for="(currency,index) in selCurrency"
                    :key="index"
                  >{{currency.currency_code.code}}</CCol>
                </CRow>
              </div>
            </template>

            <template #availablelimit="{item}">
              <td>
                <div>
                  <CRow>
                    <CCol class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                      <div
                        v-if="item[currency.currency_code.code].availablelimit"
                      >{{item[currency.currency_code.code].availablelimit.toString()|formatNumber(currency.currency_code.code)}}</div>
                    </CCol>
                  </CRow>
                </div>
              </td>
            </template>

            <template #outstanding-header>
              <div>
                <div class="d-flex">
                  <div>{{$t('cReport.outstanding')}}</div>
                </div>
                <CRow>
                  <CCol
                    class="text-center"
                    v-for="(currency,index) in selCurrency"
                    :key="index"
                  >{{currency.currency_code.code}}</CCol>
                </CRow>
              </div>
            </template>

            <template #outstanding="{item}">
              <td>
                <div>
                  <CRow>
                    <CCol class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                      <div
                        v-if="item[currency.currency_code.code].outstanding"
                      >{{item[currency.currency_code.code].outstanding.toString()|formatNumber(currency.currency_code.code)}}</div>
                    </CCol>
                  </CRow>
                </div>
              </td>
            </template>
            <template #closingoutstandingbalance-header>
              <div>
                <div class="d-flex">
                  <div>{{$t('cReport.closingOutstandingBal')}}</div>
                </div>
                <CRow>
                  <CCol
                    class="text-center"
                    v-for="(currency,index) in selCurrency"
                    :key="index"
                  >{{currency.currency_code.code}}</CCol>
                </CRow>
              </div>
            </template>

            <template #closingoutstandingbalance="{item}">
              <td>
                <div>
                  <CRow>
                    <CCol class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                      <div
                        v-if="item[currency.currency_code.code].closingoutstandingbalance"
                      >{{item[currency.currency_code.code].closingoutstandingbalance.toString()|formatNumber(currency.currency_code.code)}}</div>
                    </CCol>
                  </CRow>
                </div>
              </td>
            </template>
              <template #openingCreditlimit-header>
              <div>
                <div class="d-flex">
                  <div>{{$t('cReport.openingCreditLimit')}}</div>
                </div>
                <CRow>
                  <CCol
                    class="text-center"
                    v-for="(currency,index) in selCurrency"
                    :key="index"
                  >{{currency.currency_code.code}}</CCol>
                </CRow>
              </div>
            </template>

            <template #openingCreditlimit="{item}">
              <td>
                <div>
                  <CRow>
                    <CCol class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                      <div
                        v-if="item[currency.currency_code.code].openingCreditlimit"
                      >{{item[currency.currency_code.code].openingCreditlimit.toString()|formatNumber(currency.currency_code.code)}}</div>
                    </CCol>
                  </CRow>
                </div>
              </td>
            </template>
            
             <template #closingCreditLimit-header>
              <div>
                <div class="d-flex">
                  <div>{{$t('cReport.closingCreditLimit')}}</div>
                </div>
                <CRow>
                  <CCol
                    class="text-center"
                    v-for="(currency,index) in selCurrency"
                    :key="index"
                  >{{currency.currency_code.code}}</CCol>
                </CRow>
              </div>
            </template>

            <template #closingCreditLimit="{item}">
              <td>
                <div>
                  <CRow>
                    <CCol class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                      <div
                        v-if="item[currency.currency_code.code].closingCreditLimit"
                      >{{item[currency.currency_code.code].closingCreditLimit.toString()|formatNumber(currency.currency_code.code)}}</div>
                    </CCol>
                  </CRow>
                </div>
              </td>
            </template>
             <template #openingOutStanding-header>
              <div>
                <div class="d-flex">
                  <div>{{$t('cReport.openingOutstandingBalance')}}</div>
                </div>
                <CRow>
                  <CCol
                    class="text-center"
                    v-for="(currency,index) in selCurrency"
                    :key="index"
                  >{{currency.currency_code.code}}</CCol>
                </CRow>
              </div>
            </template>

            <template #openingOutStanding="{item}">
              <td>
                <div>
                  <CRow>
                    <CCol class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                      <div
                        v-if="item[currency.currency_code.code].openingOutStanding"
                      >{{item[currency.currency_code.code].openingOutStanding.toString()|formatNumber(currency.currency_code.code)}}</div>
                    </CCol>
                  </CRow>
                </div>
              </td>
            </template>

            <template v-for="(slotObj) in providerSlots" #[slotObj.header]>
              <div :key="slotObj.slotName">
                <div class="d-flex">
                  <div>{{slotObj.label}}</div>
                </div>
                <CRow>
                  <CCol
                    class="text-center"
                    v-for="(currency,index) in selCurrency"
                    :key="index"
                  >{{currency.currency_code.code}}</CCol>
                </CRow>
              </div>
            </template>

            <template v-for="(slotObj) in providerSlots" #[slotObj.slotName]="{item}">
              <td :key="slotObj.slotName">
                <div>
                  <CRow>
                    <CCol class="text-center" v-for="(currency,index) in selCurrency" :key="index">
                      <div
                        v-if="item[currency.currency_code.code][slotObj.slotName]"
                      >{{item[currency.currency_code.code][slotObj.slotName].toString()|formatNumber(currency.currency_code.code)}}</div>
                      <div
                        v-else-if="isDateSectionAndFooterTotal"
                      >{{item[totalDataCellProperty]?'':'0'}}</div>
                      <div v-else>{{''}}</div>
                    </CCol>
                  </CRow>
                </div>
              </td>
            </template>
            <!-- <template #show_details="{item, index}">
   <td class="py-2">
          <CButton
            color="primary"
            variant="outline"
            square
            size="sm"
          
          >
            {{ 'Show'}}
          </CButton>
            </td>                                         </template>-->
            <!-- 
            <template #details="{item}" >
              <CCollapse v-show="!item.ticketingDeadline">
                {{item}}
              </CCollapse>
              <div></div>
            </template>-->

            <template #no-items-view>
              <div class="text-center my-5">
                <h3>{{ isLoading?'':isSubmitted?$t("cReport.noItemsView"):$t("cReport.applyFilter") }}</h3>
              </div>
            </template>
            <!-- <template #thead-top>
              <thead v-if="footerTotal&&isHeaderTopTotal">
                <tr>
                  <template v-for="(field, index) in lsReportFields">
                    <th :key="index">
                      <template>
                        <td>
                          <div>
                            <CRow>
                              <CCol
                                class="text-center"
                                v-for="(currency,index) in selCurrency"
                                :key="index"
                              >
                                <div
                                  v-if="footerTotal[currency.currency_code.code]&&footerTotal[currency.currency_code.code].hasOwnProperty(field.key)"
                                >{{footerTotal[currency.currency_code.code][field.key]|formatNumber(currency.currency_code.code)}}</div>

                                <div
                                  v-else
                                >{{selCurrency&&index==selCurrency.length-1?footerTotal[field.key]:''}}</div>
                              </CCol>
                            </CRow>
                          </div>
                        </td>
                      </template>
                 
                    </th>
                  </template>
                </tr>
              </thead>
            </template> -->
            <!-- <template #caption>
              <thead v-if="footerTotal&&(isDateSectionAndFooterTotal||isFooterTotal)&&!isHeaderTopTotal">
                <tr>
                  <template v-for="(field, index) in lsReportFields">
                    <th :key="index">
                      <template>
                        <td>
                          <div>
                            <CRow>
                              <CCol
                                class="text-center"
                                v-for="(currency,index) in selCurrency"
                                :key="index"
                              >
                                <div
                                  v-if="footerTotal[currency.currency_code.code]&&(footerTotal[currency.currency_code.code].hasOwnProperty(field.key))"
                                >{{footerTotal[currency.currency_code.code][field.key]|formatNumber(currency.currency_code.code)}}</div>

                                <div
                                  v-else
                                >{{selCurrency&&index==selCurrency.length-1?footerTotal[field.key]:''}}</div>
                              </CCol>
                            </CRow>
                          </div>
                        </td>
                      </template>
                     
                    </th>
                  </template>
                </tr>
              </thead>
            </template> -->
          </cTable>
          <!-- </template>
          </cFullScreen>-->
        </div>
      </CCardBody>
    </CCard>
    <cJsonExcelModal
      v-if="showJsonExcelModal"
      :show="showJsonExcelModal"
      :desc="$t('jsonExcelModal.desc', { name:  title })"
      :onCancel="toggleJsonExcelModal"
    >
      <template #jsonExcel>
      <div @click="toggleJsonExcelModal()">
          <cExportExcel
            :isMergeCells="true"
            :data="getPrintReport()"
            :fields="getExcelFieldsForReport()"
            worksheet="Report"
            :name="getExcelFileName(title)"
          >{{ $t("jsonExcelModal.download") }}</cExportExcel>
        </div>
      </template>
    </cJsonExcelModal>
  </div>
</template>

<script>
import {VMdDateRangePicker} from "material-vue-date-picker";
import {
  addDays,
  formatDate,
  subDays
} from "../../../src/util/date/dateFunctions";
import {
  addClassToBody,
  removeClassBody,
  handleJWT,
  getErrorAlertValue,
  cloneDeep,
  cloneData,
  OrderByList,
  GroupByList,
  groupByCallBack
} from "../../../src/util/util";
import {
  PATHNAME,
  COMPONENT_NAME,
  ALERT_MODAL_STATUS,
  ORDER,
  DATE_TIME_FORMAT,
  DEFAULT_DROPDOWN_STATUS,
  AGENT_TYPE
} from "../../../src/util/constants";
import HotelDatePicker from "vue-range-datechooser";
import cAgent from "../../components/form/cAgent";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import Logger from "../../services/logger";
import BaseConfiguration from "../../config/base.js";
import SERVICE_URL from "../../../src/config/API_DATA";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import { mapActions, mapGetters } from "vuex";
import jsPDF from "jspdf";
import "jspdf-autotable";
import cReportCurrDp from "../../components/currency/cReportCurrDp";
import datePickerInput from "../../components/datePicker/datePickerInput";
import cFullScreen from "../../components/cFullScreen";
import Avatar from "vue-avatar";
import { ValidationObserver, localize, ValidationProvider } from "vee-validate";
import cPaginationLenOption from "../../components/dataTable/cPaginationLenOption";
import cExportExcel from "../../components/excel/cExportExcel";
import cJsonExcelModal from "../../components/modal/cJsonExcelModal";
import cManageColumns from "../../components/dataTable/cManageColumns";
import cTable from "../../components/dataTable/cTable";
import apiGetAirline from "../../services/apiGetAirline";
import Multiselect from "vue-multiselect";
import apiGetProviders from "../../services/apiGetProviders";
import _ from "lodash";
import { i18n } from "../../plugins/i18n.js";

export default {
  name: COMPONENT_NAME.C_REPORT,
  components: {
    VMdDateRangePicker,
    HotelDatePicker,
    cAgent,
    cReportCurrDp,
    datePickerInput,
    cFullScreen,
    Avatar,
    ValidationObserver,
    ValidationProvider,
    cPaginationLenOption,
    cExportExcel,
    cJsonExcelModal,
    cManageColumns,
    cTable,
    Multiselect
  },
  props: {
    reportName: {
      type: String,
      default: ""
    },
    listReportData: {
      type: Object,
      default: null
    },
    listReportTableData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    lsReportFields: {
      type: Array,
      default: function() {
        return [];
      }
    },
    agenttype: {
      type: Number | String,
      default: null
    },
    defaultFields: {
      type: Array,
      default: function() {
        return [];
      }
    },
    fieldsToTotal: {
      type: Array,
      default: function() {
        return [];
      }
    },
    columnsToMerge: {
      type: Array,
      default: function() {
        return [];
      }
    },
    reportDetails:{
      type:Object,
        default: function() {
        return null;
      }
    }
  },
  watch: {
    listReportData: {
      immediate: false,
      deep: true,
      handler: function(newVal, oldVal) {
        this.lsReportTableData = this.listReportTableData;

        this.lsReportData = this.listReportData;
        // this.isLoading = false;

      }
    },
    lsReportFields: {
      immediate: false,
      deep: true,
      handler: function(newVal, oldVal) {
        this.listReportFields = this.lsReportFields;
      }
    }
  },
  data: () => {
    return {
      footerTotal: null,
      title: null,
      report: {
        fromDate: new Date(),
        toDate: new Date(),
        currency: null,
        alertValue: null
      },
      agents: null,
      agencyDet: null,
      isSystemReport: false,
      selCurrency: null,
      lsAllCurrency: [],
      isAllCurrSelected: false,
      lsReportData: null,
      lsReportTableData: [],

      agentType: null,
      isSubmitted: false,
      isLoading: false,
      cReportTableWatchList: {
        filteredlistCount: null,
        itemsPerPage: 25,
        currentPageNum: 1
      },
      isSummary: false,
      showJsonExcelModal: false,
      listReportFields: null,
      lsAirlines: [],
      selAirline: null,
      isAirlineSelection: false,
      isProviderSelection: false,
      isMultipleALSel: false,
      selProvider: null,
      lsProviders: [],
      isMultipleProviderSel: false,
      isDateSectionAndFooterTotal: false,
      isFooterTotal: false,
      isNeedOverTableData: true,
      providerSlots: [],
      dateSelectionTitle: i18n.tc("cReport.reportDate"),
      isHeaderTopTotal: false,
      isAllAgentSelOption: false,
      totalDataCellProperty: null,
      isNeedAgentSelection: true,
      isCreditBalance:false,
      groupByProperty:null,
      isCreditDebitTotal:false,
      isOpenDatePickerRight:false
    };
  },

  methods: {
    customLabelForAirline(option) {
      return `${option.airline_name} `;
    },
    customLabelForProvider(option) {
      return `${option.providerDisplayName} `;
    },

    onSelAirline(pSelAirline) {
      try {
        if (BaseConfiguration.isDebug) console.log("onSelAirline");
        let selValue;

        if (pSelAirline) {
          if (pSelAirline.constructor == Object) {
            if (pSelAirline.airline_code == "All") {
              this.isMultipleALSel = false;
            } else {
              this.isMultipleALSel = true;
            }
          } else {
            for (let i = 0; i < pSelAirline.length; i++) {
              if (pSelAirline[i].airline_code == "All") {
                this.isMultipleALSel = false;
                selValue = pSelAirline[i];
              } else {
                this.isMultipleALSel = true;
              }
            }
          }
        }
        if (selValue) {
          this.selAirline = selValue;
        } else {
          this.selAirline = pSelAirline;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in onSelAirline",
          err.toString(),
          "onSelAirline",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onSelProvider(pSelAirline) {
      try {
        if (BaseConfiguration.isDebug) console.log("onSelProvider");
        let selValue;

        if (pSelAirline) {
          if (pSelAirline.constructor == Object) {
            if (pSelAirline.providerDisplayName == "All") {
              this.isMultipleProviderSel = false;
            } else {
              this.isMultipleProviderSel = true;
            }
          } else {
            for (let i = 0; i < pSelAirline.length; i++) {
              if (pSelAirline[i].providerDisplayName == "All") {
                this.isMultipleProviderSel = false;
                selValue = pSelAirline[i];
              } else {
                this.isMultipleProviderSel = true;
              }
            }
          }
        }
        if (selValue) {
          this.selProvider = selValue;
        } else {
          this.selProvider = pSelAirline;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in onSelProvider",
          err.toString(),
          "onSelProvider",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onSaveColumns(pFields) {
      try {
        if (BaseConfiguration.isDebug) console.log("onSaveColumns");
        this.listReportFields = pFields;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in onSaveColumns",
          err.toString(),
          "onSaveColumns",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getExcelFileName(pFileName) {
      let retValue;

      try {
        if (BaseConfiguration.isDebug) console.log("getExcelFileName");
        let excelDate = this.$options.filters.formatDate(new Date());
        retValue = pFileName + " - " + excelDate + ".xlsx";
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in getExcelFileName",
          err.toString(),
          "getExcelFileName",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getPrintReport() {
      let retValue = [];

      try {
        if (BaseConfiguration.isDebug) console.log("getPrintReport");
        let lsReport = JSON.parse(JSON.stringify(this.lsReportTableData));
        let dynamicColumnObj = {};
        for (let i = 0; i < lsReport.length; i++) {
          if (i == 0) {
            dynamicColumnObj = cloneDeep(lsReport[i]);
            for (let dIndex = 0; dIndex < this.defaultFields.length; dIndex++) {
              if(this.defaultFields[dIndex]&&  this.defaultFields[dIndex].key)
              dynamicColumnObj[this.defaultFields[dIndex].key] = "";
            }
          }
          lsReport[i].time = this.$options.filters.formatDateTime(
            lsReport[i].time
          );
          lsReport[i].date = this.$options.filters.formatDateTime(
            lsReport[i].date
          );
           lsReport[i].booked_ts = this.$options.filters.formatDateTime(
            lsReport[i].booked_ts
          );
           lsReport[i].daysLeft = this.$options.filters.timeLeftFormat(
            lsReport[i].ticketingDeadline
          );
          lsReport[i].orderId = lsReport[i].orderId ? lsReport[i].orderId :lsReport[i].reservationId?lsReport[i].reservationId:lsReport[i].reservasionid?lsReport[i].reservasionid:lsReport[i].orderid?lsReport[i].orderid:'';
          lsReport[i].invoice = lsReport[i].invoice ? lsReport[i].invoice : "";
                    lsReport[i].bookedBy = lsReport[i].bookedBy ? lsReport[i].bookedBy : "";

          lsReport[i].reference = lsReport[i].reference
            ? lsReport[i].reference
            : "";
          lsReport[i].description = lsReport[i].reference
            ? lsReport[i].description
            :lsReport[i].descreption? lsReport[i].descreption:"";
               lsReport[i].descreption = lsReport[i].reference
            ? lsReport[i].descreption
            : "";
          lsReport[i].firstname = lsReport[i].firstname
            ? lsReport[i].firstname + " " + lsReport[i].lastname
            : "";
          lsReport[i].booking_ref = lsReport[i].booking_ref
            ? lsReport[i].booking_ref
            : "";
          lsReport[i].tickets = lsReport[i].tickets ? lsReport[i].tickets : "";
          lsReport[i].route = lsReport[i].route ? lsReport[i].route : "";
          lsReport[i].citizentype = lsReport[i].citizentype
            ? lsReport[i].citizentype
            : "";

          if (lsReport[i].flight_info && lsReport[i].flight_info.obFlight) {
            if (!lsReport[i].class) {
              lsReport[i].class = [];
            }
            lsReport[i].class.push(
              lsReport[i].flight_info.obFlight[0].flight.Bookingclass
                ? lsReport[i].flight_info.obFlight[0].flight.Bookingclass
                : ""
            );
          } else if (
            lsReport[i].flight_info &&
            lsReport[i].flight_info.ibFlight
          ) {
            if (!lsReport[i].class) {
              lsReport[i].class = [];
            }
            lsReport[i].class.push(
              lsReport[i].flight_info.ibFlight[0].flight.Bookingclass
                ? lsReport[i].flight_info.ibFlight[0].flight.Bookingclass
                : ""
            );
          }

          lsReport[i].transactionid = lsReport[i].transactionid
            ? lsReport[i].transactionid
            : "";

          lsReport[i].transactiontype = lsReport[i].transactiontype
            ? lsReport[i].transactiontype
            :lsReport[i].transactionType?lsReport[i].transactionType: "";
          lsReport[i].currencycode = lsReport[i].currencycode
            ? lsReport[i].currencycode
            : "";
          // if (lsReport[i].currencycode) {
          //   lsReport[i].agentsales = lsReport[i][lsReport[i].currencycode]
          //     .agentsales
          //     ? lsReport[i][lsReport[i].currencycode].agentsales
          //     : 0;

          //   lsReport[i].availablelimit = lsReport[i][lsReport[i].currencycode]
          //     .availablelimit
          //     ? lsReport[i][lsReport[i].currencycode].availablelimit
          //     : 0;

          //   lsReport[i].outstanding = lsReport[i][lsReport[i].currencycode]
          //     .outstanding
          //     ? lsReport[i][lsReport[i].currencycode].outstanding
          //     : 0;

          //   lsReport[i].agentpayment = lsReport[i][lsReport[i].currencycode]
          //     .agentpayment
          //     ? lsReport[i][lsReport[i].currencycode].agentpayment
          //     : 0;

          //   lsReport[i].creditdebit = lsReport[i][lsReport[i].currencycode]
          //     .creditdebit
          //     ? lsReport[i][lsReport[i].currencycode].creditdebit
          //     : 0;

          //   lsReport[i].closingoutstandingbalance = lsReport[i][
          //     lsReport[i].currencycode
          //   ].closingoutstandingbalance
          //     ? lsReport[i][lsReport[i].currencycode].closingoutstandingbalance
          //     : 0;

          // } ///pending
          // else {
          let selCurrency = this.selCurrency;
          for (let currIndex = 0; currIndex < selCurrency.length; currIndex++) {
            let curr = selCurrency[currIndex];
            if (this.providerSlots.length > 0) {
              let columnsToMerge = this.providerSlots;

              for (let pIndex = 0; pIndex < columnsToMerge.length; pIndex++) {
                let fieldName = columnsToMerge[pIndex].slotName;

                if (currIndex == 0) {
                  lsReport[i][fieldName] =
                    lsReport[i][curr.currency_code.code][fieldName];
                } else if (pIndex == 0) {
                  lsReport[i][fieldName + "-mergeI" + currIndex] =
                    lsReport[i][curr.currency_code.code][fieldName];
                } else {
                  lsReport[i][fieldName + "-merge" + currIndex] =
                    lsReport[i][curr.currency_code.code][fieldName];
                }

                if (i == 0 && currIndex == 0) {
                  dynamicColumnObj[fieldName] = curr.currency_code.code;
                } else if (pIndex == 0) {
                  dynamicColumnObj[fieldName + "-mergeI" + currIndex] =
                    curr.currency_code.code;
                } else if (i == 0) {
                  dynamicColumnObj[fieldName + "-merge" + currIndex] =
                    curr.currency_code.code;
                }
              }
            } else {
              if (this.columnsToMerge.length > 0) {
                let columnsToMerge = this.columnsToMerge;

                for (let pIndex = 0; pIndex < columnsToMerge.length; pIndex++) {
                  let fieldName = columnsToMerge[pIndex].key;

                  if (currIndex == 0) {
                    lsReport[i][fieldName] =
                      lsReport[i][curr.currency_code.code][fieldName];
                  } else if (pIndex == 0) {
                    lsReport[i][fieldName + "-mergeI" + currIndex] =
                      lsReport[i][curr.currency_code.code][fieldName];
                  } else {
                    lsReport[i][fieldName + "-merge" + currIndex] =
                      lsReport[i][curr.currency_code.code][fieldName];
                  }

                  if (i == 0 && currIndex == 0) {
                    dynamicColumnObj[fieldName] = curr.currency_code.code;
                  } else if (pIndex == 0) {
                    dynamicColumnObj[fieldName + "-mergeI" + currIndex] =
                      curr.currency_code.code;
                  } else if (i == 0) {
                    dynamicColumnObj[fieldName + "-merge" + currIndex] =
                      curr.currency_code.code;
                  }
                }
              }
            }

          //   lsReport[i].cashOrCreditSales = lsReport[i][
          //     curr.currency_code.code
          //   ]["Credit Sales"]
          //     ? curr.currency_code.code +
          //       " " +
          //       lsReport[i][curr.currency_code.code]["Credit Sales"]
          //     : 0;
          // }
          }
        }
        lsReport.unshift(dynamicColumnObj);
        // console.error(JSON.stringify(lsReport));

        retValue = cloneData(lsReport);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in getPrintReport",
          err.toString(),
          "getPrintReport",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getExcelFieldsForReport() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getExcelFieldsForReport");
        let fields = {};
        // for (let i = 0; i < this.lsReportFields.length; i++) {
        //   fields[this.lsReportFields[i].label] = this.lsReportFields[i].key;

        // }
        // fields[this.$t("cReport.currencyCode")] = "currencycode";
        for (let i = 0; i < this.defaultFields.length; i++) {

          if( this.defaultFields[i]&&  this.defaultFields[i].label)
          fields[this.defaultFields[i].label] = this.defaultFields[i].key;
        }
        if (this.providerSlots.length > 0) {
         for (let j = 0; j < this.providerSlots.length; j++) {
          // fields[this.columnsToMerge[j].label] = this.columnsToMerge[j].key;
          for (let k = 0; k < this.selCurrency.length; k++) {
            if (k == 0) {
              fields[this.providerSlots[j].slotName] = this.providerSlots[j].slotName;
            } else if(j==0){
            fields[this.providerSlots[j].slotName + "-mergeI" + k] =
                this.providerSlots[j].slotName + "-mergeI" + k;
            }
            else {
              fields[this.providerSlots[j].slotName + "-merge" + k] =
                this.providerSlots[j].slotName + "-merge" + k;
            }
          }
        }
        } else {
          for (let j = 0; j < this.columnsToMerge.length; j++) {
            // fields[this.columnsToMerge[j].label] = this.columnsToMerge[j].key;
            for (let k = 0; k < this.selCurrency.length; k++) {
              if (k == 0) {
                 if( this.columnsToMerge[j]&&  this.columnsToMerge[j].label)
                fields[this.columnsToMerge[j].label] = this.columnsToMerge[
                  j
                ].key;
              } else if (j == 0) {
                    if(  this.columnsToMerge[j] && this.columnsToMerge[j].label)
                fields[this.columnsToMerge[j].label + "-mergeI" + k] =
                  this.columnsToMerge[j].key + "-mergeI" + k;
              } else {
                    if( this.columnsToMerge[j]&&  this.columnsToMerge[j].label)
                fields[this.columnsToMerge[j].label + "-merge" + k] =
                  this.columnsToMerge[j].key + "-merge" + k;
              }
            }
          }
        }
        retValue = cloneData(fields);
        // console.error(JSON.stringify(retValue));
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in getExcelFieldsForReport",
          err.toString(),
          "getExcelFieldsForReport",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    toggleJsonExcelModal() {
      this.showJsonExcelModal = !this.showJsonExcelModal;
    },
    onPaginationChange(pItemsPerPage) {
      try {
        if (BaseConfiguration.isDebug) console.log("onPaginationChange");
        this.cReportTableWatchList.itemsPerPage = pItemsPerPage;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in onPaginationChange",
          err.toString(),
          "onPaginationChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onPageChange(pPageNum) {
      try {
        if (BaseConfiguration.isDebug) console.log("onPageChange");
        this.cReportTableWatchList.currentPageNum = pPageNum;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in onPageChange",
          err.toString(),
          "onPageChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getFilteredAgentCount(pFilteredItems) {
      try {
        if (BaseConfiguration.isDebug) console.log("getFilteredAgentCount");
        this.cReportTableWatchList.filteredlistCount = pFilteredItems.length;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in getFilteredAgentCount",
          err.toString(),
          "getFilteredAgentCount",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getSelCurrency(pSelCurr, pOptions, pIsAllCurrSelected) {
      try {
        if (BaseConfiguration.isDebug) console.log("getSelCurrency");
        this.lsAllCurrency = pOptions;
        this.isAllCurrSelected = pIsAllCurrSelected;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in getSelCurrency",
          err.toString(),
          "getSelCurrency",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onChangeAgent(pAgent) {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangeAgent");
        //    this.agents=pAgent;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in onChangeAgent",
          err.toString(),
          "onChangeAgent",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    async getAgentDetails(pAgentDetails) {
      try {
        if (BaseConfiguration.isDebug) console.log("getAgentDetails");
        if (pAgentDetails) {
          if (BaseConfiguration.isDebug) console.log(" getAgentDetails");

          this.agencyDet = pAgentDetails;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in getAgentDetails",
          err.toString(),
          "getAgentDetails",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getCurrencyCodeLs(pSelCurrency) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getCurrencyCodeLs");
        if (pSelCurrency) {
          if (pSelCurrency.constructor == Object) {
            retValue.push(pSelCurrency.currency_code.code);
          } else {
            for (let i = 0; i < pSelCurrency.length; i++) {
              retValue.push(pSelCurrency[i].currency_code.code);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in getCurrencyCodeLs",
          err.toString(),
          "getCurrencyCodeLs",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getB2bid(pAgent) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getB2bid");
        if (pAgent) {
          if (pAgent.constructor == Object) {
            if (pAgent.b2bid) {
              retValue = pAgent.b2bid;
            }
          } else {
            if (pAgent[0].b2bid) {
              retValue = pAgent[0].b2bid;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in getB2bid",
          err.toString(),
          "getB2bid",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getGroupB2bid(pAgent) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getGroupB2bid");
        if (pAgent) {
          if (pAgent.constructor == Object && pAgent.b2bGroupid) {
            retValue = pAgent.b2bGroupid;
          } else {
            if (pAgent[0] && pAgent[0].b2bGroupid) {
              retValue = pAgent[0].b2bGroupid;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in getGroupB2bid",
          err.toString(),
          "getGroupB2bid",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getSelAirlineCodes(pSelAirlines) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getSelAirlineCodes");
        if (pSelAirlines) {
          if (pSelAirlines.constructor == Object) {
            retValue =
              pSelAirlines.airline_code == "All"
                ? null
                : [pSelAirlines.airline_code];
          } else {
            let selAirlines = [];
            for (let i = 0; i < pSelAirlines.length; i++) {
              selAirlines.push(pSelAirlines[i].airline_code);
            }
            retValue = selAirlines;
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in getSelAirlineCodes",
          err.toString(),
          "getSelAirlineCodes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getSelProviders(pSelProviders) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getSelProviders");
        if (pSelProviders) {
          if (pSelProviders.constructor == Object) {
            retValue =
              pSelProviders.providerDisplayName == "All"
                ? null
                : [pSelProviders.providerid];
          } else {
            let selProvider = [];
            for (let i = 0; i < pSelProviders.length; i++) {
              selProvider.push(pSelProviders[i].providerid);
            }
            retValue = selProvider;
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in getSelProviders",
          err.toString(),
          "getSelProviders",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    async onReportFormSubmit() {
      try {
        if (BaseConfiguration.isDebug) console.log("onReportFormSubmit");
        // this.isLoading = true;
        this.lsReportData = null;
        this.lsReportTableData = [];
        this.footerTotal = null;

        if (this.isAllCurrSelected) {
          this.selCurrency = this.lsAllCurrency;
        } else {
          if (this.report.currency.constructor == Object) {
            this.selCurrency = [this.report.currency];
          } else {
            this.selCurrency = this.report.currency;
          }
        }
        let lsCurrCode = this.getCurrencyCodeLs(this.selCurrency);
        let b2bid = this.getB2bid(this.agents);
        let groupB2bid = this.getGroupB2bid(this.agents);

        let fromDate = formatDate(
          this.report.fromDate,
          DATE_TIME_FORMAT.API_DATE_FORMAT
        );
        let toDate = formatDate(
          this.report.toDate,
          DATE_TIME_FORMAT.API_DATE_FORMAT
        );
        let selAirlineCode = this.getSelAirlineCodes(this.selAirline);
        let selProvider = this.getSelProviders(this.selProvider);
        let emitData = {
          fromDate: fromDate,
          toDate: toDate,
          lsCurrCode: lsCurrCode,
          b2bid: b2bid,
          groupId: groupB2bid,
          airlineCode: selAirlineCode,
          provider: selProvider
        };
        this.lsReportTableData = [];
        this.lsReportData = null;
        if (selProvider) {
          this.$emit("submit", emitData, this.selProvider);
        } else {
          this.$emit("submit", emitData, this.lsProviders);
        }
        this.isSubmitted = true;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in onReportFormSubmit",
          err.toString(),
          "onReportFormSubmit",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getMinYear() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getMinYear");
        retValue = new Date().getFullYear() - 10 + "";
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in getMinYear",
          err.toString(),
          "getMinYear",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getMaxYear() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getMaxYear");
        retValue = new Date().getFullYear() + 1 + "";
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in getMaxYear",
          err.toString(),
          "getMaxYear",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    onChangeDate(pDateList) {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangeDate");
        this.report.fromDate = pDateList[0]._d;
        this.report.toDate = pDateList[1]._d;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in onChangeDate",
          err.toString(),
          "onChangeDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    assignReportName(pReportName) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignReportName");

        switch (pReportName) {
          case COMPONENT_NAME.AGENT_PREPAID_REPORT:
            this.title = this.$t("cReport.agentPrepaidReport");
            this.agentType = 1;
            this.isCreditDebitTotal=true;
            break;
          case COMPONENT_NAME.AGENT_PREPAID_SUMMARY:
            this.title = this.$t("cReport.agentPrepaidSummary");
            this.isSummary = true;
            this.agentType = 1;
            this.isCreditDebitTotal=true;
            this.isOpenDatePickerRight=true;
            break;
          case COMPONENT_NAME.AGENT_POSTPAID_REPORT:
            this.title = this.$t("cReport.agentPostpaidReport");
            this.agentType = 2;
            this.isDateSectionAndFooterTotal = true;
            this.isHeaderTopTotal=true;
            this.totalDataCellProperty = "transactiontype";
            this.groupByProperty="time"
            this.isNeedOverTableData = false;
            

            break;
          case COMPONENT_NAME.AGENT_POSTPAID_SUMMARY:
            this.title = this.$t("cReport.agentPostpaidSummary");
            this.isSummary = true;
            this.agentType = 2;
            this.isNeedOverTableData = false;
            this.isHeaderTopTotal=true;
            this.totalDataCellProperty = "agencyname";
            this.isOpenDatePickerRight=true;

            
            break;
          case COMPONENT_NAME.TOPUP_FORECAST_REPORT:
            this.agentType = this.agenttype;
            if(this.agentType==AGENT_TYPE.PREPAID){
            this.title = this.$t("cReport.TopupForecastReportPrepaid");
              this.isOpenDatePickerRight=true;
            }else if(this.agentType==AGENT_TYPE.POSTPAID){
             this.title = this.$t("cReport.TopupForecastReportPostpaid"); 
             this.isOpenDatePickerRight=true;
            }else{
            this.title = this.$t("cReport.TopupForecastReport");
            }
            this.isAirlineSelection = true;
            this.isProviderSelection = true;
            this.isDateSectionAndFooterTotal = true;
            this.dateSelectionTitle = this.$t("cReport.ticketingDeadline");
            this.totalDataCellProperty = "orderId";
                        this.groupByProperty="ticketingDeadline";

            if (this.isSystemReport) {
              this.isNeedOverTableData = false;
            }
               this.isAllAgentSelOption = true;

            break;
          case COMPONENT_NAME.DAILY_OR_PERIODICAL_SALES_REPORT:
            this.title = this.$t("cReport.dailyOrPeriodicalReport");
            this.isNeedOverTableData = false;
            this.dateSelectionTitle = this.$t("cReport.selectPeriod");
            this.isAirlineSelection = true;
            this.isProviderSelection = true;
            this.isHeaderTopTotal = true;
            this.isAllAgentSelOption = true;
            this.totalDataCellProperty = "agencyname";

            break;
          case COMPONENT_NAME.PERIODICAL_SALES_DETAIL_REPORT:
            this.title = this.$t("cReport.detailReport");
            this.isNeedOverTableData = false;
            this.isFooterTotal = true;
            this.isNeedAgentSelection = false;
            this.totalDataCellProperty = "tourCode";
                        this.isOpenDatePickerRight=true;

            break;
          case COMPONENT_NAME.TOPUP_PROJECTION_REPORT:
            this.title = this.$t("cReport.topupProjectionReport");
            this.agentType = this.agenttype;
            this.dateSelectionTitle = this.$t("cReport.bookingDate");
                        this.isOpenDatePickerRight=true;

            break;
          case COMPONENT_NAME.CREDIT_SALES_REPORT:
            if(this.reportDetails){
             this.title = this.reportDetails.name;
            }
            this.isCreditBalance=true;
           
            this.dateSelectionTitle = this.$t("cReport.selectTransactionDate");
                        this.isOpenDatePickerRight=true;

            break;
            
          default:
            break;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in assignReportName",
          err.toString(),
          "assignReportName",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async getAllAirlines() {
      let airportList = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getAllAirlines");
        // let pGetAllAirlineReq = {
        //   contractcode: "",
        //   description: "",
        //   airline_code: "",
        //   traveldate_from: "",
        //   traveldate_to: "",
        //   ticketingdate_from: "",
        //   ticketingdate_to: "",
        //   isfareonly_contract: "",
        //   providerid: null
        // };
        let airportRequest = apiGetAirline.buildRequest();

        if (airportRequest) {
          let airportResponse = await apiGetAirline.getResponse(airportRequest);

          if (VALIDATE_SUCCESS_RES(airportResponse)) {
            this.alertValue = null;
            airportList = airportResponse.data.data;
          } else {
            let error = getErrorMessage(airportResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in getAllAirlines",
          err.toString(),
          "getAllAirlines",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return airportList;
    },
    async getProviders() {
      let providerList = [];

      try {
        if (BaseConfiguration.isDebug) console.log("getProviders");
        try {
          if (BaseConfiguration.isDebug) console.log("getAllAirlines");

          let providerRequest = apiGetProviders.buildRequest();

          if (providerRequest) {
            let providerResponse = await apiGetProviders.getResponse(
              providerRequest
            );

            if (VALIDATE_SUCCESS_RES(providerResponse)) {
              this.alertValue = null;
              providerList = providerResponse.data.data;
            } else {
              let error = getErrorMessage(providerResponse);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          }
        } catch (err) {
          let body = Logger.buildRequest(
            COMPONENT_NAME.C_REPORT,
            "error in getAllAirlines",
            err.toString(),
            "getAllAirlines",
            LOG_TYPE.ERROR
          );
          Logger.getResponse(body);
        }
        return providerList;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in getProviders",
          err.toString(),
          "getProviders",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async initialFormats() {
      try {
        if (BaseConfiguration.isDebug) console.log("initialFormats");
        if (this.AGENT_SIGNIN_RES) {
          this.isSystemReport = false;
          this.agencyDet = {};
          this.agentType = this.AGENT_SIGNIN_RES.logoDetails.agenttype;
        } else {
          this.isSystemReport = true;
        }
        this.assignReportName(this.reportName);
        if (this.fieldsToTotal.length > 0) {
          let providerSlots = this.fieldsToTotal;
          for (let i = 0; i < providerSlots.length; i++) {
            let slot = {
              header: providerSlots[i].key + "-header",
              slotName: providerSlots[i].key,
              label:providerSlots[i].label
            };
            this.providerSlots.push(slot);
          }
        }
        this.listReportFields = this.lsReportFields;
        if (this.isAirlineSelection) {
          let lsAirlines = await this.getAllAirlines();
          if (lsAirlines.length > 0) {
            lsAirlines.unshift({
              id: "0",
              airline_code: DEFAULT_DROPDOWN_STATUS.ALL,
              airline_name: DEFAULT_DROPDOWN_STATUS.ALL
            });
            this.selAirline = lsAirlines[0];
          }
          this.lsAirlines = lsAirlines;
        }

        if (this.isProviderSelection) {
          let lsProviders = await this.getProviders();
          if (lsProviders.length > 0) {
            for (let i = 0; i < lsProviders.length; i++) {
              let slot = {
                header: lsProviders[i].providerDisplayName + "-header",
                slotName: lsProviders[i].providerDisplayName,
                label:lsProviders[i].providerDisplayName

              };
              this.providerSlots.push(slot);
            }
            lsProviders.unshift({
              id: "0",
              providerDisplayName: DEFAULT_DROPDOWN_STATUS.ALL,
              providerid: DEFAULT_DROPDOWN_STATUS.ALL
            });
            this.selProvider = lsProviders[0];
          }
          this.lsProviders = lsProviders;
          this.$emit("getProviders", this.lsProviders);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REPORT,
          "error in initialFormats",
          err.toString(),
          "initialFormats",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  },
  computed: {
    ...mapGetters("sSysLogin", {
      ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
    }),
    ...mapGetters("sAgtLogin", {
      AGENT_SIGNIN_RES: "GET_SIGNIN_RES"
    }),
    DATE_TIME_FORMAT() {
      return DATE_TIME_FORMAT;
    },
    reportComputedList() {
      let retValue = [];
      if(this.lsReportTableData&&this.lsReportTableData.length>0){
      if(this.isDateSectionAndFooterTotal&&this.groupByProperty){
      let that=this;
      let lsGroupedReportData = _.groupBy(this.lsReportTableData, function(
        item
      ) {
        return formatDate(
          item[that.groupByProperty],
          DATE_TIME_FORMAT.REPORT_DATE_FORMAT
        );
      });
      if (lsGroupedReportData && Object.keys(lsGroupedReportData).length) {
        // let
        // let footerTotal = cloneDeep(
        //   lsGroupedReportData[Object.keys(lsGroupedReportData)[0]][0]
        // );

        for (let i = 0; i < Object.keys(lsGroupedReportData).length; i++) {
          const dateGroupList =
            lsGroupedReportData[Object.keys(lsGroupedReportData)[i]];
          let totalObjToInsert = cloneDeep(dateGroupList[0]);
          for (
            let groupIndex = 0;
            groupIndex < dateGroupList.length;
            groupIndex++
          ) {
            if (this.selCurrency) {
              for (
                let currIndex = 0;
                currIndex < this.selCurrency.length;
                currIndex++
              ) {
                let currCode = this.selCurrency[currIndex].currency_code.code;
                for (
                  let provIndex = 0;
                  provIndex < this.providerSlots.length;
                  provIndex++
                ) {
                  let provider = this.providerSlots[provIndex].slotName;
                  if(provider!='closingoutstandingbalance'&&provider!='availablelimit'){
                    
                  
                  if (groupIndex != 0) {
                    totalObjToInsert[currCode][provider] =
                      Number(totalObjToInsert[currCode][provider]) +
                      Number(dateGroupList[groupIndex][currCode][provider]);
                  }
                  // if (i != 0 || groupIndex != 0) {
                  //   footerTotal[currCode][provider] =
                  //     Number(footerTotal[currCode][provider]) +
                  //     Number(dateGroupList[groupIndex][currCode][provider]);
                  // }
                  }else{
                    if(groupIndex==dateGroupList.length-1){
                    
                      if(dateGroupList[groupIndex][currCode][provider]==null){
                       let lastElementWithValue;
                        for(let revIndex=dateGroupList.length-1;revIndex>=0;revIndex--){
                          if(dateGroupList[revIndex][currCode][provider]!=null){
                           lastElementWithValue= Number(dateGroupList[revIndex][currCode][provider]);
                           break;
                          }
                        }
                        if(!lastElementWithValue){
                          totalObjToInsert[currCode][provider] =0;
                        }else{
                           totalObjToInsert[currCode][provider] =lastElementWithValue;
                        }
                        
                      }else{
                         totalObjToInsert[currCode][provider] =
                      Number(dateGroupList[groupIndex][currCode][provider]);
                      }
                      // if(i==0){
                      //     footerTotal[currCode][provider] =
                      // Number(dateGroupList[groupIndex][currCode][provider]);
                      // }else{
                      //      footerTotal[currCode][provider] =
                      // Number(footerTotal[currCode][provider]) +
                      // Number(dateGroupList[groupIndex][currCode][provider]);
                      // }
                     
                    }
                     
                  }
                
                }
              }
            }
            retValue.push(dateGroupList[groupIndex]);
          }
          for (
            let fieldIndex = 0;
            fieldIndex < this.defaultFields.length;
            fieldIndex++
          ) {
            if (
              this.defaultFields[fieldIndex].key == this.totalDataCellProperty
            ) {
              totalObjToInsert[this.defaultFields[fieldIndex].key] =
                Object.keys(lsGroupedReportData)[i] + ' '+this.$t("cReport.total");
            } else {
              totalObjToInsert[this.defaultFields[fieldIndex].key] = "";
            }
          }
          totalObjToInsert._classes = "table-info";
          if (this.isDateSectionAndFooterTotal) {
            retValue.push(totalObjToInsert);
          }
          // console.error(JSON.stringify(totalObjToInsert))
        }
        // for (
        //   let fieldIndex = 0;
        //   fieldIndex < this.defaultFields.length;
        //   fieldIndex++
        // ) {
        //   if (
        //     this.defaultFields[fieldIndex].key == this.totalDataCellProperty
        //   ) {
        //     footerTotal[this.defaultFields[fieldIndex].key] = this.$t("cReport.total");
        //   } else {
        //     footerTotal[this.defaultFields[fieldIndex].key] = "";
        //   }
        // }
        // this.footerTotal = footerTotal;
      }
      }
      // else{
      //   let lsReportTableData=cloneData(this.lsReportTableData);
      //     let totalObjToInsert=cloneDeep(lsReportTableData[0]);
      //    for (let i = 0; i < lsReportTableData.length; i++) {
         
         
      //       if (this.selCurrency) {
      //         for (
      //           let currIndex = 0;
      //           currIndex < this.selCurrency.length;
      //           currIndex++
      //         ) {
      //           let currCode = this.selCurrency[currIndex].currency_code.code;
      //           for (
      //             let provIndex = 0;
      //             provIndex < this.providerSlots.length;
      //             provIndex++
      //           ) {
      //             let provider = this.providerSlots[provIndex].slotName;
      //             if (i != 0) {
      //               totalObjToInsert[currCode][provider] =
      //                 Number(totalObjToInsert[currCode][provider]) +
      //                 Number(lsReportTableData[i][currCode][provider]);
      //             }
                  
      //           }
      //         }
      //       }
      //       retValue.push(lsReportTableData[i]);
      //        }
        
      //      for (
      //     let fieldIndex = 0;
      //     fieldIndex < this.defaultFields.length;
      //     fieldIndex++
      //   ) {
      //     if (
      //       this.defaultFields[fieldIndex].key == this.totalDataCellProperty
      //     ) {
      //       totalObjToInsert[this.defaultFields[fieldIndex].key] = "Total";
      //     } else {
      //       totalObjToInsert[this.defaultFields[fieldIndex].key] = "";
      //     }
      //   }
     
       
        
      //   this.footerTotal = totalObjToInsert;
      // }
      }
      return retValue;
    
    
    }
    // reportComputedList() {
    //   let retValue = [];
    //   let lsGroupedReportData = _.groupBy(this.lsReportTableData, function(
    //     item
    //   ) {
    //     return formatDate(
    //       item.ticketingDeadline,
    //       DATE_TIME_FORMAT.REPORT_DATE_FORMAT
    //     );
    //   });
    //   for (let i = 0; i < Object.keys(lsGroupedReportData).length; i++) {
    //     const dateGroupList =
    //       lsGroupedReportData[Object.keys(lsGroupedReportData)[i]];
    //     let totalObjToInsert = cloneDeep(dateGroupList[0]);

    //     for (
    //       let groupIndex = 0;
    //       groupIndex < dateGroupList.length;
    //       groupIndex++
    //     ) {
    //       for (
    //         let currIndex = 0;
    //         currIndex < this.selCurrency.length;
    //         currIndex++
    //       ) {
    //         let currCode = this.selCurrency[currIndex].currency_code.code;
    //         for (
    //           let provIndex = 0;
    //           provIndex < this.providerSlots.length;
    //           provIndex++
    //         ) {
    //           let provider = this.providerSlots[provIndex].slotName;
    //           if (groupIndex != 0) {
    //             totalObjToInsert[currCode][provider] =
    //               totalObjToInsert[currCode][provider] +
    //               dateGroupList[groupIndex][currCode][provider];
    //           }
    //         }
    //       }
    //       retValue.push(dateGroupList[groupIndex]);
    //     }
    //     for (
    //       let fieldIndex = 0;
    //       fieldIndex < this.defaultFields.length;
    //       fieldIndex++
    //     ) {
    //       if (
    //         this.defaultFields[fieldIndex].key == "orderId"
    //       ) {
    //         totalObjToInsert[this.defaultFields[fieldIndex].key] = Object.keys(lsGroupedReportData)[i]+' Total';
    //       } else {
    //         totalObjToInsert[this.defaultFields[fieldIndex].key] = "";
    //       }
    //     }
    //     retValue.push(totalObjToInsert);
    //   }

    //   return retValue;
    // }
  },
  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
      await this.initialFormats();
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.C_REPORT,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  }
};
</script>

<style>
</style>